

const en_us = {

    /* Navigation Panel */
    Home: "Home",
    Home_Link: "https://ksfire.org/",
    About: "About",
    About_Link: "https://ksfire.org/about/",
    Environment: "Environment",
    Environment_Link: "https://ksfire.org/environment/",
    Regulations: "Regulations",
    Regulations_Link: "https://ksfire.org/regulations/",
    Education: "Education",
    Education_Link: "https://ksfire.org/education/",
    Health: "Health",
    Health_Link: "https://ksfire.org/health/",
    Events: "Events",
    Events_Link:"https://ksfire.org/events",
    Research: "Research",
    Research_Link: "https://ksfire.org/research/",
    Weather: "Weather",
    Weather_Link: "https://ksfire.org/weather/",
    News_Archives: "News Archives",
    News_Archives_Link: "https://ksfire.org/news-media-archives/",
    Radio: "Radio",
    Radio_Link: "https://ksfire.org/radio/",
    Prescribed_Burning: "Prescribed Burning",
    Prescribed_Burning_Link: "https://ksfire.org/prescribed-burning/",
    Woody_Encroachment: "Woody Encroachment",
    Woody_Encroachment_Link: "https://ksfire.org/woody-encroachment/",
    Burn_Info: "Burn Info",
    Burn_Info_Link: "https://ksfire.org/burn-info/",

    /* Subnavigation Panel */
    SubNav_About_Link: "/view/about",
    Cumulative_Fire_Impacts: "Cumulative Fire Impacts",
    SubNav_Summary_Link: "/view/summary",
    Your_Fire_Impacts: "Your Fire Impacts",
    SubNav_Details_Link: "/view/details",

    /* Page Title */
    About_Page_Title: "Kansas Flint Hills Smoke Management - About",
    Summary_Page_Title: "Kansas Flint Hills Smoke Management - Cumulative Fire Impacts",
    Details_Page_Title: "Kansas Flint Hills Smoke Management - Your Fire Impacts",
    Default_Page_Title: "Kansas Flint Hills Smoke Management",

    /* Landing Page */
    Title: "Kansas Flint Hills Smoke Management",
    Subtitle: "Kansas Fire Modeling",

    /* About Page */
    About_Welcome_Title: "Welcome to the Kansas Fire Modeling Page",
    About_Welcome_P1: "The Flint Hills Smoke Management Plan encourages land managers to use model predictions in making" +
        " the final decision to burn. Models have been developed specifically for use with the Smoke Management Plan." +
        " These models predict the potential contribution to urban area air quality problems. They do not provide" +
        " information about whether conditions are safe to conduct a burn. Where required by local ordinance, check with" +
        " your local public safety official regarding fire safety questions.",
    About_Cumulative_Title: "Cumulative Fire Impact",
    About_Cumulative_P1: "Two forecast models have been developed. The Cumulative Fire Impact map is generated by the" +
        " first model. The map shows the predicted potential contributions of smoke from each county to air quality in" +
        " urban areas. This information is based on the assumption that multiple fires will be occurring simultaneously" +
        " across the Flint Hills. The model uses emission rates from burn days in prior years when air quality in" +
        " downwind cities exceeded air quality standards. These data, coupled with currently predicted weather" +
        " conditions, provide an overall look at air quality impacts for a two-day period. A map is generated for each" +
        " day, with each county colored to represent the predicted contribution of fires in that county to air quality" +
        " in monitored areas of Kansas and Nebraska:",
    About_Impacts_Title: "Your Fire Impacts",
    About_Impacts_P1:"A second model (available under the Your Fire Impacts tab) shows the direction and extent of the" +
        " predicted plume from a single burn. To use this model, select the county in which the burn is located, the" +
        " number of acres to be burned, and the estimated fuel load (light, average, or heavy). An animated map" +
        " displays the smoke plume and its movement over the following 48 hours. You can review the plume movement to" +
        " determine whether it impacts downwind monitored areas. The animated plume only shows the impacts of the local" +
        " fire, not those of neighboring regions.",
    About_Forecast_Title: "Forecast Discussion",
    About_Forecast_P1: "A discussion of weather conditions is also provided so you can further evaluate whether better" +
        " days for burning lie ahead. When planning a prescribed burn it is important to consider the smoke plume" +
        " models, local weather conditions, and factors that contribute to burning safely. Developing an effective" +
        " burn plan will ensure that all relevant components are considered prior to burning.",
    About_Attribution: <div>
        Powered By <a className={'about-link'} href={'http://www.sonomatech.com/'} target={'_blank'}>
            Sonoma Technology, inc
        </a>.
    </div>,

    /* Fire Table */
    FireTable_Green_Name: "Green",
    FireTable_Green_Hex: "#00e400",
    FireTable_Green_Description: "Fires in the county are expected to have a small contribution.",
    FireTable_Yellow_Name: "Yellow",
    FireTable_Yellow_Hex: "#ffff00",
    FireTable_Yellow_Description: "Fires in the county are expected to have a medium contribution. Air quality from" +
        " fires may be impacted.",
    FireTable_Red_Name: "Red",
    FireTable_Red_Hex: "#ff0000",
    FireTable_Red_Description: "Fires in the county are expected to have a large contribution. Air quality from fires" +
        " may be significantly impacted. Please consider postponing burning to a later date.",
    FireTable_White_Name: "White",
    FireTable_White_Hex: "#fff",
    FireTable_White_Description: "The county is not included in the model",
    FireTable_Black_Text: "#333",
    FireTable_White_Text: "#fff",
    FireTable_Color: "Color",
    FireTable_Potential_Contribution: "Potential Contribution",

    /* Contribution Table */
    Contribution_Table_Header: "Potential Contribution to Major Cities for Fires Ignited On",
    Contribution_Table_Max: "Maximum Contribution Potential within 48 hours",
    Contribution_Table_Small: "Small Contribution",
    Contribution_Table_Medium: "Medium Contribution",
    Contribution_Table_Large: "Large Contribution",
    Contribution_Table_Unavailable: "Data Unavailable",
    Contribution_Table_Metro: "Metropolitan Area",
    Contribution_Table_Monitor: "Monitor",
    Contribution_Table_County: "County",
    Contribution_Table_Contribution: "Contribution",
    No_Data_Available: "No data available",

    /* Forecast Table */
    Forecast_Table_Discussion: "Forecast Discussion",
    Forecast_Table_Extended: "Extended Forecast",
    Forecast_Discussion_Unavailable: "Forecast Discussion is currently unavailable.",
    Forecast_Table_Extended_Unavailable: "Extended Forecast is currently unavailable.",

    /* Summary Page */
    Summary_Disclaimer_P1: <div>
        The tools provided below are to access air quality information only. For burn safety
        decisions, please consult other resources such as the <a className={'summary-link'} href='https://www.weather.gov/top/fire' target='_blank'>
        Topeka, Kansas</a> or <a className={'summary-link'} href='https://www.weather.gov/ict/fire' target='_blank'>Wichita, Kansas</a> National
        Weather Service websites.
    </div>,
    Summary_Range_P1: "Fire impact predictions only available from ",
    Summary_Range_P2: " through ",
    Summary_Range_P3: ".",
    Summary_Forecast_Update: "Forecasts are updated daily at 1:00 p.m. Central Time.",
    Summary_View_As: "View as:",
    Summary_Map: "Map",
    Summary_Divider: "|",
    Summary_Table: "Table",

    /* Details Page */
    Details_Disclaimer_P1: <div>
        The tools provided below are to access air quality information only. For burn safety
        decisions, please consult other resources such as the <a className={'summary-link'} href='https://www.weather.gov/top/fire' target='_blank'>
        Topeka, Kansas</a> or <a className={'summary-link'} href='https://www.weather.gov/ict/fire' target='_blank'>Wichita, Kansas</a> National
        Weather Service websites.
    </div>,

    /* Details Input Table */
    Input_Header_Fuel: "Fuel Load",
    Input_Header_County: "County",
    Input_Header_Size: "Size",
    Input_Header_Date: "Date",
    Input_Fuel_Load_Light: "Light",
    Input_Fuel_Load_Medium: "Medium",
    Input_Fuel_Load_Heavy: "Heavy",
    Input_Size_Small: "<1000 acres",
    Input_Size_Medium: "1000-5000 acres",
    Input_Size_Large: ">5000 acres",
    Input_Submit: "View Your Fire Impacts",

    /* Details Impact Table */
    Impact_Header: "48-Hour Impact Potential For Fires Ignited On",
    Impact_County_Subheader: "You are now looking at the impact potential for a fire in ",
    Impact_County: " County.",
    Impact_Increment: ">",
    Impact_Decrement: "<",
    Impact_Start: "Start",
    Impact_Stop: "Stop",
    Impact_Central_Time: "Central Time",

    /* Mobile Page */
    Mobile_Disclaimer: "This tool is provided to access air quality information only.",
    Mobile_Select_County: "Select your county from the list below.",
    Mobile_Cumulative_P1: "The Cumulative Fire Impact is represented by the colored labels on the mobile" +
        " home page. The page shows the predicted potential contributions of smoke from each county to air" +
        " quality in urban areas. This information is based on the assumption that multiple fires will be occurring" +
        " simultaneously across the Flint Hills.",
    Mobile_Cumulative_P2: "The model uses emission rates from burn days in prior years when air quality in downwind" +
        " cities exceeded air quality standards. These data, coupled with currently predicted weather conditions," +
        " provide an overall look at air quality impacts for a two-day period. Data is generated daily, with each" +
        " county colored to represent the predicted contribution of fires in that county to air quality in Kansas City," +
        " Wichita, and Topeka.",
    Mobile_View_Full_Site: "View Full Site",

}

export default en_us